module.exports = __webpack_public_path__ + "img/tom.f7e93563.jpeg";